import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/solid";
import React from "react";

type SortIconProps = {
  isSorting: boolean;
  isSortedAsc: boolean;
  size?: number;
};

const SIZE = 16;

const SortIcon = ({ isSorting, isSortedAsc, size = SIZE }: SortIconProps) => {
  return (
    <div className="flex flex-col items-center">
      <ChevronUpIcon
        width={size}
        height={size}
        className={`-mb-1 ${
          isSorting ? (!isSortedAsc ? "" : "opacity-0") : ""
        }`}
      />
      <ChevronDownIcon
        width={size}
        height={size}
        className={`-mt-1 ${isSorting ? (isSortedAsc ? "" : "opacity-0") : ""}`}
      />
    </div>
  );
};

export default SortIcon;
